import './search_slide.css';
import './schedule_result.css';
import {RouteTabs} from "./table_line/route_tabs";
import {TabContent} from "./table_line/tab_content";
import {MobileContainer} from "./mobile_container/mobile-container";

export const ScheduleResult = {
    props: {
        is_active: {
            type: Boolean,
            required: true,
        },
        is_mobile: {
            type: Boolean,
            required: true,
        },
        departure: {
            type: Object,
            required: true,
        },
        arrival: {
            type: Object,
            required: true,
        },
        date: {
            type: String,
            required: true,
        },
        schedule: {
            today: {
                date: '',
                trips: [],
            },
            tomorrow: {
                date: '',
                trips: [],
            },
        }
    },
    components: {
        RouteTabs,
        TabContent,
        MobileContainer,
    },
    data(): object
    {
        return {
            current_tab: 'today'
        }
    },
    computed: {
        tripsTodayCount()
        {
            return this.getNameTrips(Object.keys(this.schedule.today.trips).length);
        },
        tripsTomorrowCount()
        {
            return this.getNameTrips(Object.keys(this.schedule.tomorrow.trips).length);
        },
    },
    methods: {
        getLengthTrips(trips)
        {
            return Object.keys(trips).length;
        },

        switchTab(tab)
        {
            if (typeof this.schedule[tab] !== 'undefined') {
                this.current_tab = tab
            }
        },
        getNameTrips(trip_count)
        {
            let return_text = '';
            if (typeof trip_count !== 'number') {
                trip_count = 0;
            }
            const reg = new RegExp(`^(.*)(\\d)$`, `gmi`);
            let trip_count_txt = '' + trip_count;
            let matches = reg.exec(trip_count_txt);
            switch (parseInt(matches[2])) {
                case 1:
                    return_text = trip_count + ' рейс';
                    break;
                case 2:
                case 3:
                case 4:
                    return_text = trip_count + ' рейса';
                    break;
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 0:
                    return_text = trip_count + ' рейсов';
                    break;
            }
            return return_text;
        },
    },
    template: `
        <MobileContainer
            :is_active="is_active"
            :is_mobile="is_mobile"
            :current_day="current_tab"
            :departure="departure"
            :arrival="arrival"
            :date="date"
            :schedule="schedule"
        />
        <div class="buy-ticket__result search-result" v-if="is_active === true && is_mobile === false">
            <div class="search-result__title">
                <div class="search-result__titile-text">Рейс из {{departure}} до {{arrival}} {{date}}</div>
            </div>
            <div class="search-result__container">
                <div class="search-result__days-list days-list">
                    <div class="days-list__wrapper">
                        <RouteTabs
                            v-for="(trip_day, trip_day_key) in schedule" :key="trip_day_key"
                            :is_active="trip_day_key === current_tab"
                            :title="schedule[trip_day_key].date"
                            :count_length="getNameTrips(getLengthTrips(schedule[trip_day_key].trips))"
                            @click.stop.prevent="switchTab(trip_day_key)"
                        />
                    </div>
                </div>
                <div class="search-result__routs-table routs-table">
                    <div class="routs-table__wrapper">
                        <div class="routs-table__list">
                            <div class="routs-table__header">
                                <div class="routs-table__header-wrapper">
                                    <div class="routs-table__header-field routs-table__num">
                                        <span>Рейс</span>
                                    </div>
                                    <div class="routs-table__header-field routs-table__name">
                                        <span>Название маршрута</span>
                                    </div>
                                    <div class="routs-table__header-field routs-table__time">
                                        <span>Отправление</span>
                                    </div>
                                    <div class="routs-table__header-field routs-table__arrival">
                                        <span>Прибытие</span>
                                    </div>
                                    <div class="routs-table__header-field routs-table__spent">
                                        <span>В пути</span>
                                    </div>
                                    <div class="routs-table__header-field routs-table__link">
                                        <span>Тариф </span>
                                    </div>
                                </div>
                            </div>
                            <div class="routs-table__body">
                                <TabContent
                                    v-for="(trip_day, trip_day_key) in schedule" :key="trip_day_key"
                                    :is_active="trip_day_key === current_tab"
                                    :current_day="current_tab"
                                    :trip="trip_day.trips"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`,
}